import { render, staticRenderFns } from "./PlanningComponent.vue?vue&type=template&id=0bf67797&scoped=true"
import script from "./PlanningComponent.vue?vue&type=script&lang=js"
export * from "./PlanningComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf67797",
  null
  
)

export default component.exports